export const BASE_URL = "https://lifetimeinfotech.in/backend/";
// export const BASE_URL = "http://localhost/Lifetimeinfotech/Backend/";
